// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"177":"home","243":"skills","417":"experience","421":"contacts","443":"about","609":"team"}[chunkId] + "." + {"177":"86a92c39","243":"821334a2","417":"39e372a9","421":"4001c093","443":"d8499c48","609":"0449ee78"}[chunkId] + ".chunk.css";
};